/* tslint:disable */
/* eslint-disable */
export enum WorkLinkSerialnumberWithProjectResultEnum {
  Ok = 'OK',
  Error = 'ERROR',
  AlreadyLinked = 'ALREADY_LINKED',
  NotFound = 'NOT_FOUND'
}
